class MegamenuNav extends HTMLElement {
  connectedCallback() {
    this.triggers = Array.from(this.querySelectorAll('[data-megamenu-trigger]'));
    this.panels = Array.from(this.querySelectorAll('[data-megamenu-panel]'));

    const details = this.closest('details');
    if (details) {
      details.addEventListener('toggle', () => {
        if (details.open && this.triggers.length) {
          this.showPanel(this.triggers[0].dataset.megamenuTrigger);
        } else {
          this.hideAll();
        }
      });
    }

    this.querySelectorAll('.megamenu__nav-item').forEach((item) => {
      const trigger = item.querySelector('[data-megamenu-trigger]');
      item.addEventListener('mouseenter', () => {
        if (trigger) {
          this.showPanel(trigger.dataset.megamenuTrigger);
        } else {
          this.hideAll();
        }
      });
    });

    this.triggers.forEach((trigger) => {
      trigger.addEventListener('focus', () => this.showPanel(trigger.dataset.megamenuTrigger));
    });

    this.addEventListener('mouseleave', () => {
      if (this.triggers.length) {
        this.showPanel(this.triggers[0].dataset.megamenuTrigger);
      }
    });
  }

  showPanel(handle) {
    this.triggers.forEach((t) => {
      t.setAttribute('aria-expanded', t.dataset.megamenuTrigger === handle ? 'true' : 'false');
    });
    this.panels.forEach((p) => {
      p.hidden = p.dataset.megamenuPanel !== handle;
    });
  }

  hideAll() {
    this.triggers.forEach((t) => t.setAttribute('aria-expanded', 'false'));
    this.panels.forEach((p) => (p.hidden = true));
  }
}

customElements.define('megamenu-nav', MegamenuNav);
